module.exports = __webpack_public_path__ + "img/ic_16_fitnessplan_cancel.039ba489.svg";